import i18n from '@/translations';
import Store from '@/store';

const LOGOUT_SUCCESS_MESSAGE = i18n.messages[i18n.locale].logout['success-message'];
const LOGOUT_FAILED_MESSAGE = i18n.messages[i18n.locale].logout['fail-message'];

const LOGOUT_ENDPOINTS = Object.keys(i18n.messages)
	.map(locale => i18n.messages[locale].routes.logout);

export default ({
	run: (to, from, next) => {
		// Check if logout is requested
		if (LOGOUT_ENDPOINTS.indexOf(to.path) > -1) {
			Store.dispatch('sso/LOGOUT')
				.then(() => {
					Store.dispatch('application/LOGOUT_MESSAGE', {
						success: true,
						message: LOGOUT_SUCCESS_MESSAGE,
					}).then(() => {
						next({ name: `login-${i18n.locale}` });
					});
				})
				.catch(() => {
					Store.dispatch('application/LOGOUT_MESSAGE', {
						success: false,
						message: LOGOUT_FAILED_MESSAGE,
					})
						.then(() => {
							next({ name: `login-${i18n.locale}` });
						});
				});
			return true;
		}
		return false;
	},
});
